"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setActiveWorkspace = void 0;
const LocalStorage_1 = require("../../../utility/LocalStorage");
function setActiveWorkspace(draft, action) {
    if (action.payload) {
        const { workspace } = action.payload;
        const localData = (0, LocalStorage_1.getLocalStorage)('nmr-general-settings');
        draft.workspace.current = workspace;
        localData.currentWorkspace = workspace;
        (0, LocalStorage_1.storeData)('nmr-general-settings', JSON.stringify(localData));
    }
}
exports.setActiveWorkspace = setActiveWorkspace;
